import store from '@/state/store'
import {getUserLang, setUserLang} from "../utils/auth";

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
      breadcrumb: [
        {
          text:"Default",
          active: true
        }
      ]
    },
    component: () => {
      if (getUserLang() =='en')
      return import('./views/dashboards/default_en')
      else
      return import('./views/dashboards/default')
    },
  },
  {
    path: '/overview',
    name: 'overview',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/Overview'),
  },
  {
    path: '/vacancyindex',
    name: 'vacancyindex',
    meta: {
      authRequired: true,
      pageTitle:"Vacancy Index",
      breadcrumb: [
        {
          text: 'VacancyIndex',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/vacancy/VacancyIndex')
  },
  {
    path: '/rankinformation/:id',
    name: 'rankinformation',
    meta: {
      authRequired: true,
      pageTitle:"Rank Information",
      breadcrumb: [
        {
          text: 'Rank Information',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/vacancy/RankInformation')
  },
  {
    path: '/frankinformation/:id',
    name: 'frankinformation',
    meta: {
      authRequired: true,
      pageTitle:"Rank Information",
      breadcrumb: [
        {
          text: 'Rank Information',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/vacancy/FRankInformation')
  },
  {
    path: '/positioninformation/:id',
    name: 'positioninformation',
    meta: {
      authRequired: true,
      pageTitle:"Position Information",
      breadcrumb: [
        {
          text: 'Position Information',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/vacancy/PositionInformation')
  },
  {
    path:'/personalinformation',
    name: 'personalinformation',meta: {
      authRequired: true,
      pageTitle:"Personal Information",
      breadcrumb: [
        {
          text: 'Personal Information',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/online-test/PersonalInformation')
  },
  {
    path: '/testlanguage/:testId',
    name: 'testlanguage',
    meta: {
      authRequired: true,
      pageTitle:"Test Language",
      breadcrumb: [
        {
          text: 'Test Language',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/online-test/test/TestLanguage')
  },
  {
    path: '/test/:testId/:lang',
    name: 'test',
    meta: {
      authRequired: true,
      pageTitle:"Test",
      breadcrumb: [
        {
          text: 'Test',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/online-test/test/Test')
  },
  {
    path: '/test-answers/:testId',
    name: "TestAnswers",
    meta: {
      authRequired: true,
      pageTitle:"Test Answers",
      breadcrumb: [
        {
          text: 'Test Answers',
          active: true,
        },
      ],
    },
    component: () => import("./views/dashboards/admin-panel/school/test-results/TestAnswers")
  },
  {
    path: '/register/:vacancyId',
    name: 'register',
    meta: {
      authRequired: true,
      pageTitle:"Register",
      breadcrumb: [
        {
          text: 'Register',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/vacancy/Register')
  },
  {
    path: '/fregister/:vacancyId',
    name: 'fregister',
    meta: {
      authRequired: true,
      pageTitle:"Register",
      breadcrumb: [
        {
          text: 'Register',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/vacancy/FRegister')
  },
  {
    path: '/moderator-profile',
    name: 'moderator-profile',
    meta: {
      authRequired: true,
      pageTitle:"Moderator Profile",
      breadcrumb: [
        {
          text: 'Moderator Profile',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/ModeratorProfile')
  },
  {
    path: '/statistics',
    name: 'statistics',
    meta: {
      authRequired: true,
      pageTitle:"Statistics",
      breadcrumb: [
        {
          text: 'Statistics',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/school/statistics/Statistics')
  },
  {
    path: '/jobs',
    name: 'jobs',
    meta: {
      authRequired: true,
      pageTitle:"Jobs",
      breadcrumb: [
        {
          text: 'Jobs',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/school/jobs/jobs/Jobs')
  },
  {
    path: '/addjob',
    name: 'addjob',
    meta: {
      authRequired: true,
      pageTitle:"Add Job",
      breadcrumb: [
        {
          text: 'Add Job',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/school/add-job/AddJob')
  },
  {
    path: '/editjob/:id',
    name: 'editjob',
    meta: {
      authRequired: true,
      pageTitle:"Edit Job",
      breadcrumb: [
        {
          text: 'Edit Job',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/school/add-job/AddJob')
  },
  {
    path: '/job-information/:id',
    name:'job-information',
    meta: {
      authRequired: true,
      pageTitle:"Job Information",
      breadcrumb: [
        {
          text: 'Job Information',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/school/jobs/jobs/job-information')
  },

  { // фронтофисдан хориди вакансия куриш
    path: '/fvacancyindex',
    name: 'fvacancyindex',
    meta: {
      authRequired: true,
      pageTitle:"Vacancies for foreigners",
      breadcrumb: [
        {
          text: 'Vacancies for foreigners',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/vacancy/FVacancyIndex')
  },

  { // админкадан хорижи вакансия кушиш
    path: '/fjobs',
    name: 'fjobs',
    meta: {
      authRequired: true,
      pageTitle:"fJobs",
      breadcrumb: [
        {
          text: 'fJobs',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/school/jobs/jobs/FJobs')
  },
  { // админкадан хорижи вакансия кушиш
    path: '/add-foreign-job',
    name: 'add-foreign-job',
    meta: {
      authRequired: true,
      pageTitle:"Add Foreign Job",
      breadcrumb: [
        {
          text: 'Add Foreign Job',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/school/add-job/AddForeignJob')
  },

  {
    path: '/fjob-information/:id',
    name:'fjob-information',
    meta: {
      authRequired: true,
      pageTitle:"FJob Information",
      breadcrumb: [
        {
          text: 'FJob Information',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/school/jobs/jobs/fjob-information')
  },


  {
    path:'/applications',
    name: 'applications',
    meta: {
      authRequired: true,
      pageTitle:"Applications",
      breadcrumb: [
        {
          text: 'Applications',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/school/applications/Applications')
  },
  {
    path:'/testresults-main',
    name:'testresults-main',
    meta: {
      authRequired: true,
      pageTitle:"Test Results",
      breadcrumb: [
        {
          text: 'Test Results',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/school/test-results/TestResultMain')
  },
  {
    path: '/testresults/:id',
    name: 'testresults',
    meta: {
      authRequired: true,
      pageTitle:"Test Result",
      breadcrumb: [
        {
          text: 'Test Result',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/school/test-results/TestResults')
  },
  {
    path: '/test-result-action/:id',
    name: 'test-result-action',
    meta: {
      authRequired: true,
      pageTitle:"Test Result Action",
      breadcrumb: [
        {
          text: 'Test Result Action',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/school/test-results/TestResultAction')
  },
  {
    path: "/tests",
    name: 'tests',
    meta: {
      authRequired: true,
      pageTitle:"Tests",
      breadcrumb: [
        {
          text: 'Tests',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/test/add-title/Tests')
  },
  {
    path: '/test-questions/:id',
    name: 'test-questions',
    meta: {
      authRequired: true,
      pageTitle:"Test Questions",
      breadcrumb: [
        {
          text: 'Test Questions',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/test/test-questions/TestQuestions')
  },
  {
    path:'/test-candidates',
    name: 'test-candidates',
    meta: {
      authRequired: true,
      pageTitle:"Test Candidates",
      breadcrumb: [
        {
          text: 'Test Candidates',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/test/TestCandidates')
  },
  {
    path: '/test-result',
    name: 'test-result',
    meta: {
      authRequired: true,
      pageTitle:"Test-result",
      breadcrumb: [
        {
          text: 'Test-result',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/test/TestCandidates')
  },
  {
    path: '/schools/:oblastid/:regionid',
    name: 'schools',
    meta: {
      authRequired: true,
      pageTitle:"Schools",
      breadcrumb: [
        {
          text: 'Schools',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/schools/Schools')
  },
  {
    path: '/tillar',
    name:'tillar',
    meta: {
      authRequired: true,
      pageTitle:"Languages",
      breadcrumb: [
        {
          text: 'Languages',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/languages/languages')
  },
  {
    path: '/experience',
    name:'experience',
    meta: {
      authRequired: true,
      pageTitle:"Experience",
      breadcrumb: [
        {
          text: 'Experience',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/work_experience/work_experience')
  },
  {
    path: '/job-types',
    name: 'job-types',
    meta: {
      authRequired: true,
      pageTitle:"Job Types",
      breadcrumb: [
        {
          text: 'Job Types',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/job-types/jobTypes')
  },
  {
    path: '/education',
    name: 'education',
    meta: {
      authRequired: true,
      pageTitle:"Education",
      breadcrumb: [
        {
          text: 'Education',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/education/Education')
  },
  {
    path:'/language-level',
    name:'language-level',
    meta: {
      authRequired: true,
      pageTitle:"Language Level",
      breadcrumb: [
        {
          text: 'Language Level',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/language-knowledge-level/KnowledgeLevel')
  },
  {
    path: '/work-places',
    name: 'work-places',
    meta: {
      authRequired: true,
      pageTitle:"Work places",
      breadcrumb: [
        {
          text: 'Work places',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/work-places/WorkPlaces')
  },
  {
    path: '/payment-type',
    name:'payment-type',
    meta: {
      authRequired: true,
      pageTitle:"Payment types",
      breadcrumb: [
        {
          text: 'Payment types',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/payment_type/PaymentType')
  },
  {
    path: '/add-school',
    name: 'add-school',
    meta: {
      authRequired: true,
      pageTitle:"Add school",
      breadcrumb: [
        {
          text: 'Add school',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/schools/AddSchool')
  },
  {
    path:'/users',
    name: 'users',
    meta: {
      authRequired: true,
      pageTitle:"Users",
      breadcrumb: [
        {
          text: 'Users',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/users/Users')
  },
  {
    path: '/regions',
    name: 'regions',
    meta: {
      authRequired: true,
      pageTitle:"Regions",
      breadcrumb: [
        {
          text: 'Regions',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/region/regions/Regions')
  },
  {
    path: '/region/:id',
    name: 'region',
    meta: {
      authRequired: true,
      pageTitle:"Region",
      breadcrumb: [
        {
          text: 'Region',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/region/Region')
  },
  {
    path: '/rank-level',
    name: 'rank-level',
    meta: {
      authRequired: true,
      pageTitle:"Rank level",
      breadcrumb: [
        {
          text: 'Rank level',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/rank/rank-level/RankLevel')
  },
  {
    path: '/ranks',
    name: 'ranks',
    meta: {
      authRequired: true,
      pageTitle:"Ranks",
      breadcrumb: [
        {
          text: 'Ranks',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/rank/Ranks')
  },
  {
    path: '/subject-name',
    name: 'subject-name',
    meta: {
      authRequired: true,
      pageTitle:"Subject Name",
      breadcrumb: [
        {
          text: 'Subject Name',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/subject-name/Index')
  },
  {
    path: '/lidership-experience',
    name: 'lidership-experience',
    meta: {
      authRequired: true,
      pageTitle:"Lidership experience",
      breadcrumb: [
        {
          text: 'Lidership experience',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/lidership_experience/Lidership_experience')
  },
  {
    path: '/category',
    name:'category',
    meta: {
      authRequired: true,
      pageTitle:"Category",
      breadcrumb: [
        {
          text: 'Category',
          active: true,
        },
      ],
    },
    component: () => import('./views/dashboards/admin-panel/moderator/category/Category')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    // meta: {
    //   beforeResolve(routeTo, routeFrom, next) {
    //     // If the user is already logged in
    //     if (store.getters['auth/loggedIn']) {
    //       // Redirect to the home page instead
    //       next({ name: 'default' })
    //     } else {
    //       // Continue to the login page
    //       next()
    //     }
    //   },
    // },
  },
  {
    path: '/register/:vacancyId',
    name: 'Register',
    component: () => import('./views/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch('auth/logOut')
        } else {
          store.dispatch('authfack/logout')
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },

  {
    path: '/en',
    name: 'en',
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        setUserLang('en')
        next({ name: 'default' })
      },
    },
  },
  {
    path: '/uz',
    name: 'uz',
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        setUserLang('uz')
        next({ name: 'default' })
      },
    },
  },



]
